module.exports = __webpack_public_path__ + "Normal.png?96b9876e6b7453652148c133c125783c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/art/Normal.png
// module id = 118
// module chunks = 0